import { Grid } from "@mui/material";
import React, { useEffect } from "react";
import { updateMainHeader } from "../../commonFunctions/CommonFunctions";
import { breadCrumbsStore } from "../../Components/BreadCrumbs/BreadCrumbsListner";
import { CustomerTabList } from "./CustomerTabList";
import { DoctorTabList } from "./DoctorTabList";
import { VendorTabList } from "./VendorTabList";

// Standalone list pages for the sidebar's Doctors / Customers / Vendors menus.
// Each reuses the list that was previously only reachable as a tab under Contacts.
const ContactPage: React.FC<{ header: string; breadCrumb: string; path: string; children: React.ReactNode }> =
  ({ header, breadCrumb, path, children }) => {
    useEffect(() => {
      updateMainHeader(header);
      breadCrumbsStore.updateBreadCrumbs([{ [breadCrumb]: path }]);
    }, [header, breadCrumb, path]);

    return (
      <Grid container spacing={2}>
        <Grid item xs={12}>
          {children}
        </Grid>
      </Grid>
    );
  };

export const DoctorPage: React.FC = () => (
  <ContactPage header="Doctors" breadCrumb="Doctor List" path="/doctor/list">
    <DoctorTabList />
  </ContactPage>
);

export const CustomerPage: React.FC = () => (
  <ContactPage header="Customers" breadCrumb="Customer List" path="/customer/list">
    <CustomerTabList />
  </ContactPage>
);

export const VendorPage: React.FC = () => (
  <ContactPage header="Vendors" breadCrumb="Vendor List" path="/vendor/list">
    <VendorTabList />
  </ContactPage>
);
